/* istanbul ignore file */
/**
 * Created by gboue on 8/30/22
 * File: ConfigureIdpModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useCallback, useMemo, useState, CSSProperties } from 'react'
import {
  Modal,
  ModalHeader, ModalProps,
} from '@panwds/react-ui'
import {
  STEP_CONFIGURE, STEP_PROVIDE_SAML, TITLE_CONFIGURE_IDP
} from '../../../constants/LabelConstants'
import Sidebar from '../../common/modal/sidebar/Sidebar'
import ConfigureSAML from '../forms/ConfigureSAML'
import ProvideSAMLMetadata from '../forms/ProvideSAMLMetadata'
import type { ISamlMetadata } from '../cards/ProviderCard'
import _ from 'lodash'

const SIDEBAR_OPTIONS = {
  STEP_CONFIGURE_METHOD: {
    name: STEP_CONFIGURE,
  },
  STEP_PROVIDE_SAML_META: {
    name: STEP_PROVIDE_SAML,
  }
}

const ConfigureIdpModal: VFC<ModalProps & {
   closeModal: () => void,
   domain: string,
   userFederation: {},
   federations: {},
   fetchData: Function,
   idps?: any,
   isEdit?: boolean,
   idpId?: string,
 }> = ({ isOpen, closeModal, domain, userFederation, federations, fetchData, isEdit = false, idps, idpId }) => {
   const idpData = idps?.[0]
   const [url, setUrl] = useState('')
   const [loading, setLoading] = useState(false)
   const [samlMetadata, setSamlMetadata] = useState<ISamlMetadata | null>(null)
   const [uploadedFileName, setUploadedFileName] = useState('')
   const [activeStep, setActiveStep] = useState(isEdit ? SIDEBAR_OPTIONS.STEP_PROVIDE_SAML_META : SIDEBAR_OPTIONS.STEP_CONFIGURE_METHOD)
   const [error, setError] = useState(false)

   const onBackPressed = useCallback(() => {
     switch (activeStep) {
       case SIDEBAR_OPTIONS.STEP_PROVIDE_SAML_META:
         setSamlMetadata(null)
         setUrl('')
         setError(false)
         setUploadedFileName('')
         setActiveStep(SIDEBAR_OPTIONS.STEP_CONFIGURE_METHOD)
         break
       case SIDEBAR_OPTIONS.STEP_CONFIGURE_METHOD:
       default:
         closeModal()
     }
   }, [activeStep, closeModal])

   const onNextPressed = useCallback(() => {
     switch (activeStep) {
       case SIDEBAR_OPTIONS.STEP_CONFIGURE_METHOD:
         setActiveStep(SIDEBAR_OPTIONS.STEP_PROVIDE_SAML_META)
         break
       default:
         closeModal()
     }
   }, [activeStep, closeModal])

   const activeStepContent = useMemo(() => {
     switch (activeStep) {
       case SIDEBAR_OPTIONS.STEP_CONFIGURE_METHOD:
         return <ConfigureSAML {...{ error, setError, domain, uploadedFileName, setUploadedFileName, federations, userFederation, setLoading, setSamlMetadata, samlMetadata, loading, onBackPressed, onNextPressed, url, setUrl }} />
       case SIDEBAR_OPTIONS.STEP_PROVIDE_SAML_META:
         return <ProvideSAMLMetadata {...{ setUploadedFileName, fetchData, uploadedFileName, samlMetadata, loading, onBackPressed, onNextPressed, setLoading, domain, closeModal, isEdit, idpData, idpId }} />
       default:
         return ''
     }
   }, [error, setError, fetchData, userFederation, uploadedFileName, setUploadedFileName, federations, activeStep, loading, onBackPressed, onNextPressed, setUrl, closeModal, url, samlMetadata, domain, isEdit, idpData, idpId])

   const sidebarOptions = useMemo(() => Object.values(_.cloneDeep(SIDEBAR_OPTIONS)), [])

   return (
     <Modal
       size='lg'
       style={{ top: '50%', '--tw-translate-y': '-50%', minHeight: '600px', minWidth: '800px' } as CSSProperties}
       onClose={closeModal}
       {...{ isOpen }}
     >
       <ModalHeader title={TITLE_CONFIGURE_IDP} />
       <div className="tw-flex tw-flex-1 tw-relative tw-max-h-full">
         <Sidebar options={sidebarOptions} currentOption={activeStep}/>
         <div className="tw-absolute tw-right-0 tw-bottom-0 tw-top-0" style={{ left: '200px' }}>
           {activeStepContent}
         </div>
       </div>
     </Modal>
   )
 }

ConfigureIdpModal.propTypes = {}
export default ConfigureIdpModal

